<div style="position: relative;">

    <swiper [slidesPerView]="1"
            [watchOverflow]="true" 
            [spaceBetween]="0" 
            [pagination]="{ clickable: true }" 
            (swiper)="onSkillsSwiper($event)"
            (slideChange)="onSlideChange()" 
            class="w-100 overflow-mobile promotion-slider"
    >
        <ng-template swiperSlide class="container px-0" *ngFor="let slide of slides">
            <img loading="lazy" *ngIf="slide?.image" [src]="slide?.image" class="swiper-static-image hide-mobile"  alt=""/>

            <div class="row px-0 action-container">
                <div class="col-12 px-0">
                    <img loading="lazy" *ngIf="slide?.image" [src]="slide?.image" class="swiper-static-image show-mobile d-none" />

                    <span class="d-none show-mobile">
                        <ng-container *ngIf="slide?.content?.link?.includes('http') || slide?.content?.link?.includes('mailto')">
                            <a class="special-btn" href="{{ slide?.content?.link }}" target="_blank">
                                <button type="button" class="btn btn-primary px-10" style="margin-right: 40px;"
                                        [style.background-color]="slide?.content?.btn_color"
                                        [style.border-color]="slide?.content?.btn_color">
                                    {{ slide?.content?.link_text }}
                                </button>
                            </a>
                        </ng-container>
                        <ng-container *ngIf="!slide?.content?.link?.includes('http') && !slide?.content?.link?.includes('mailto')">
                            <a class="special-btn" routerLink="{{ slide?.content?.link }}">
                                <button type="button" class="btn btn-primary px-10" style="margin-right: 40px;"
                                    [style.background-color]="slide?.content?.btn_color"
                                    [style.border-color]="slide?.content?.btn_color">
                                    {{ slide?.content?.link_text }}
                                </button>
                            </a>
                        </ng-container>
                    </span>

                    <div class="div-left d-flex align-items-center">
                        <div class="content text-center text-lg-left">
                            <h2 class="font-weight-light text-white" [innerHTML]="slide?.content?.title | safeHtml"></h2>
                            <p class="font-size-16" [innerHTML]="slide?.content?.description | safeHtml"></p>
                            <ng-container *ngIf="slide?.content?.link?.includes('http') || slide?.content?.link?.includes('mailto')">
                                <a href="{{ slide?.content?.link }}" target="_blank">
                                    <button type="button" class="btn btn-primary rounded-pill px-10 mt-5 font-weight-bold font-size-16"
                                            [style.background-color]="slide?.content?.btn_color"
                                            [style.border-color]="slide?.content?.btn_color">
                                        {{ slide?.content?.link_text }}
                                    </button>
                                </a>
                            </ng-container>
                            <ng-container *ngIf="!slide?.content?.link?.includes('http') && !slide?.content?.link?.includes('mailto')">
                                <a routerLink="{{ slide?.content?.link }}">
                                    <button type="button" class="btn btn-primary rounded-pill px-10 mt-5 font-weight-bold font-size-16"
                                            [style.background-color]="slide?.content?.btn_color"
                                            [style.border-color]="slide?.content?.btn_color">
                                        {{ slide?.content?.link_text }}
                                    </button>
                                </a>
                            </ng-container>
                        </div>
                    </div>

                    <div class="div-right d-none _d-inline-flex align-items-center justify-content-end">
                        <a routerLink="{{ slide?.content?.link }}">
                            <button type="button" class="d-none btn btn-primary px-10" style="margin-right: 40px;"
                                [style.background-color]="slide?.content?.btn_color"
                                [style.border-color]="slide?.content?.btn_color">
                                {{ slide?.content?.link_text }}
                            </button>
                        </a>

                        <ng-container *ngIf="slide?.content?.link?.includes('http') || slide?.content?.link?.includes('mailto')">
                            <a href="{{ slide?.content?.link }}" target="_blank">
                                <button type="button" class="d-none btn btn-primary px-10" style="margin-right: 40px;"
                                        [style.background-color]="slide?.content?.btn_color"
                                        [style.border-color]="slide?.content?.btn_color">
                                    {{ slide?.content?.link_text }}
                                </button>
                            </a>
                        </ng-container>
                        <ng-container *ngIf="!slide?.content?.link?.includes('http') && !slide?.content?.link?.includes('mailto')">
                            <a routerLink="{{ slide?.content?.link }}">
                                <button type="button" class="d-none btn btn-primary px-10" style="margin-right: 40px;"
                                        [style.background-color]="slide?.content?.btn_color"
                                        [style.border-color]="slide?.content?.btn_color">
                                    {{ slide?.content?.link_text }}
                                </button>
                            </a>
                        </ng-container>
                    </div>

                </div>
            </div>
        </ng-template>
    </swiper>

    <div class="swiper-buttons text-right" *ngIf="slides?.length > 1">
        <button class="btn btn-white shadow-xs rounded-circle btn-previous" [class.disabled]="isBegin"
            (click)="gotoPrevious()">
            <mat-icon aria-hidden="false" aria-label="Previous">arrow_back</mat-icon>
        </button>
        <button class="btn btn-white shadow-xs rounded-circle btn-next" [class.disabled]="isEnd" (click)="gotoNext()">
            <mat-icon aria-hidden="false" aria-label="Next">arrow_forward</mat-icon>
        </button>
    </div>
</div>